/**
 * Aruba WLANs store — drives the /aruba/wlans page.
 *
 * Same shape as aruba-sites — load + falls-back-to-empty-on-error. Pulls
 * from /api/aruba/wlans/ which proxies Aruba's /monitoring/v2/networks
 * endpoint (live SSID broadcast list, not the per-group config templates).
 */
import { create } from "zustand";
import { get as apiGet, ApiError } from "@/api/client";
import { ArubaWlanListSchema, type ArubaWlan } from "@/api/schemas/aruba";

interface State {
  data: ArubaWlan[];
  status: "idle" | "loading" | "ready" | "error";
  error: string | null;
  load: () => Promise<void>;
}

export const useArubaWlans = create<State>((set, get) => ({
  data: [],
  status: "idle",
  error: null,

  load: async () => {
    if (get().status === "loading") return;
    set({ status: "loading", error: null });
    try {
      const raw = await apiGet<unknown>("/aruba/wlans/");
      set({ data: ArubaWlanListSchema.parse(raw), status: "ready" });
    } catch (err) {
      const message =
        err instanceof ApiError
          ? `API error ${err.status}`
          : err instanceof Error
            ? err.message
            : "unknown error";
      set({ data: [], status: "error", error: message });
    }
  },
}));
